import { matchPath, useLocation } from 'react-router-dom';
import { CURRICULUM_ROUTES } from '../constants/routes';
var useCurrentRoute = function () {
    var location = useLocation();
    return Object.values(CURRICULUM_ROUTES).find(function (route) {
        return matchPath(route, location.pathname);
    });
};
export { useCurrentRoute };
